(() => {
  const END = Date.parse('2026-08-22T09:30:00Z');
  if (!Number.isFinite(END)) return;
  const expired = () => Date.now() >= END;
  function guard() {
    if (!expired()) return;
    document.querySelectorAll('[data-kamok-depo][data-context="cart"].kamok-depo--smart').forEach((root) => {
      root.classList.remove('kamok-depo--smart');
      const smart = root.querySelector('[data-kamok-depo-smart]');
      const rail = root.querySelector('[data-kamok-depo-list]');
      const head = root.querySelector('[data-kamok-depo-heading]');
      const sub = root.querySelector('[data-kamok-depo-subheading]');
      if (smart) { smart.hidden = true; smart.innerHTML = ''; }
      if (rail) {
        [...rail.children].forEach((node, index) => { node.hidden = index >= 3; });
        rail.hidden = rail.children.length === 0;
      }
      if (head) head.textContent = 'Dar gali prireikti';
      if (sub) sub.textContent = 'Tik susiję priedai';
      root.hidden = !rail || rail.children.length === 0;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard, { once: true });
  else guard();
  new MutationObserver(guard).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden'] });
})();
